import React from 'react'
import profileImg2 from '../../images/profileimg2.jpeg';
import "./Biography.scss"
import { Container, Row, Col } from "react-bootstrap";
const Biography = () => {
  return (
    <Container>
        <Row className="container-box align-items-center">
            <Col xl={6} lg={6} sm={12}>
                <div  className='profile-image'>
                    <img className="profile" src={profileImg2} alt='img'></img>
                </div>
            </Col>
            <Col xl={6} lg={6} sm={12}>
                <div  className='profile-text'>
                    <h4>Universidad de Concepción</h4>
                    <h2>Macarena Pereira</h2>
                    <p>
                    Soy abogada de la Universidad de Concepción, con una fuerte formación en Derecho Civil y especializaciones en legislación tributaria (Universidad de Chile), derecho laboral con certificación en Ley Karin (ADIPA); responsabilidad penal de las personas jurídicas, forensic y compliance nacional e internacional (Universidad de Valladolid). 
                    Mi formación también abarca áreas de interés como los conflictos familiares, patrimoniales, contractuales, la propiedad intelectual, derecho ambiental y nuevas tecnologías, lo que me permite abordar desafíos legales con una visión integral y estratégica de los derechos y del negocio jurídico. 
                    Más allá del ejercicio tradicional del derecho, he liderado proyectos en áreas tan diversas como gestión cultural, administración de empresas y producción de proyectos, siempre desde un enfoque legal y creativo. Esta experiencia interdisciplinaria ha fortalecido mi capacidad de asesoría, especialmente para empresas que buscan anticiparse a los riesgos legales sin frenar su crecimiento.
                    Busco ser siempre cercana, directa y comprometida, representando a una nueva generación de abogadas que entiende el Derecho como un aliado del desarrollo empresarial y humano.
                    </p>
                </div>
            </Col>
        </Row>
    </Container>
  )
}

export default Biography